export const handleClick = () => {
  if (typeof window['OneTrust'] !== 'undefined') {
    window['OneTrust'].ToggleInfoDisplay();
  }
};
